import styles from "./cockpit.module.css";

/**
 * Boot indicator shown where the cockpit will appear: first as the Suspense
 * fallback while the scene chunk downloads, then inside the stage until the
 * first frame renders. Kept out of the lazy chunk so it paints immediately.
 */
export function CockpitLoader({
  story = false,
  done = false,
}: {
  story?: boolean;
  done?: boolean;
}) {
  return (
    <div
      className={`${styles.loader} ${story ? styles.loaderStory : ""}`}
      data-done={done ? "1" : "0"}
      role="status"
      aria-label="Loading cockpit"
    >
      <span className={styles.loaderTrack}>
        <span className={styles.loaderBar} />
      </span>
      <span className={styles.loaderLabel}>Booting cockpit</span>
    </div>
  );
}
